@let featureCheck = features$ | async;
@if (featureCheck && featureCheck.canShow) {
  @if (divider()) {
    <hr />
  }
  @if (featureCheck.isEnabled) {
    <ng-container *ngTemplateOutlet="content" />
  } @else {
    @if (disabledTemplate()) {
      <ng-container *ngTemplateOutlet="disabledTemplate()" />
    } @else {
      <div class="not-enabled">
        <plugins-notice>
          <div
            class="not-enabled__text"
            [innerHtml]="
              customWarning() ??
                (disabledTranslationKey()
                  | translate: featureCheck.disabledMessageArgs) | dompurify
            "
          ></div>
        </plugins-notice>
      </div>
    }
    @if (warningType() === 'backoffice') {
      <div class="not-enabled__projected">
        <ng-container *ngTemplateOutlet="content" />
      </div>
    }
  }
}

<ng-template #content><ng-content /></ng-template>
